<div class="time-account-chart-container">
    <div class="grid">
        <div class="col-12">
            <div class="chart-controls">
                <div class="flex justify-content-between align-items-center">
                    <div class="time-range-selector col-12">
                        <div class="grid">
                            <div [ngClass]="{'col-12': true, 'md:col-6': selectedTimeRange.value === -2}">
                                <mat-form-field appearance="outline" class="w-full">
                                    <mat-label>{{ 'txTimeSumsChart.timeRange' | translate }}</mat-label>
                                    <mat-select [formControl]="selectedTimeRange" panelClass="select-full-height">
                                        <mat-option>{{ 'txTimeSumsChart.pleaseSelect' | translate }}</mat-option>
                                        <mat-option *ngFor="let option of timeRangeOptions" [value]="option.value">
                                            {{ ('txTimeSumsChart.timeRanges.' + option.value) | translate }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="selectedTimeRange.invalid">{{ 'txTimeSumsChart.selectTimeRange' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div *ngIf="selectedTimeRange.value === -2" class="col-12 md:col-6">
                                <mat-form-field appearance="outline" class="flex-1">
                                    <mat-label>{{ 'txTimeSumsChart.date' | translate }}</mat-label>
                                    <mat-date-range-input [rangePicker]="picker">
                                        <input matStartDate placeholder="{{ 'general.dateFormat' | translate }}" [formControl]="selectedStartDate">
                                        <input matEndDate placeholder="{{ 'general.dateFormat' | translate }}" [formControl]="selectedEndDate">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedTimeRange.value !== null">
                <mat-tab-group class="col-12">
                    <mat-tab label="{{ 'txZeitKonto.bookings' | translate }}">
                        <div class="chart-wrapper" style="position: relative;">
                            <div *ngIf="loading" class="loading-overlay">
                                <div class="spinner">
                                    <mat-spinner diameter="40"></mat-spinner>
                                </div>
                            </div>
                            <canvas #chartCanvas></canvas>
                        </div>
                    </mat-tab>
                    <mat-tab [label]="'txTimeSumsChart.absences' | translate">
                        <div class="chart-wrapper" style="position: relative;">
                            <div *ngIf="loading" class="loading-overlay">
                                <div class="spinner">
                                    <mat-spinner diameter="40"></mat-spinner>
                                </div>
                            </div>
                            <canvas #absenceChartCanvas></canvas>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>

            <div *ngIf="selectedTimeRange.value === null" class="mt-4 p-4 text-center">
                <p>{{ 'txTimeSumsChart.selectTimeRangeToShowData' | translate }}</p>
            </div>
        </div>
    </div>
    <div *ngIf="selectedTimeRange.value !== null">
        <mat-card class="info-box mt-3">
            <mat-card-content>
                <div class="flex align-items-center">
                    <mat-icon class="info-icon mr-2">info</mat-icon>
                    <span>{{ 'txTimeSumsChart.timeValuesDisclaimer' | translate }}</span>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
